<script>
import store from '@state/store'
import { debounce } from 'debounce'
import { Cropper } from 'vue-advanced-cropper'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import VueTagsInput from '@johmun/vue-tags-input'
import Datepicker from 'vuejs-datepicker'
import { parseISO } from 'date-fns/fp'
import isDate from 'lodash/isDate'

const GOALS_DATA = [
  {
    type: 'donation',
    label: 'Donation',
    goal: '0',
  },
  {
    type: 'volunteered',
    label: 'Hours',
    goal: '0',
  },
  {
    type: 'kyndness',
    label: 'PENCIL Positives',
    goal: '0',
  },
  {
    type: 'gratitude',
    label: 'Gratitude',
    goal: '0',
  },
]

const GOALS_LABEL = {
  donation: 'Donation',
  volunteered: 'Hours',
  kyndness: 'PENCIL Positives',
  gratitude: 'Gratitude',
}

const POST_TYPES_OPTIONS = [
  { value: 'all', name: 'All' },
  { value: 'donation', name: 'Donation' },
  { value: 'volunteered', name: 'Volunteering' },
  { value: 'kyndness', name: 'Kyndness' },
  { value: 'gratitude', name: 'Gratitude' },
]

const GOAL_SETTING_OPTIONS = [
  { value: 'time', name: 'Time Based' },
  { value: 'number', name: 'Target Number' },
]

const EMPTY_TIME = '0000-00-00 00:00:00'

export default {
  components: {
    Cropper,
    VueTagsInput,
    Datepicker,
  },
  mixins: [validationMixin],
  props: {
    companyId: { type: [String, Number], required: true },
    groupItem: { type: Object, required: false, default: null },
  },
  data() {
    return {
      detailForm: {
        groupName: '',
        parentId: '',

        start: '',
        end: '',

        imageUrl: '',

        postTypes: '',
        goals: [],
        goalSetting: 'time',
        goalsEnd: '',

        causeTags: [],
        orgTags: [],
      },
      groups: [],

      postTypesOptions: POST_TYPES_OPTIONS,
      goalSettingOptions: GOAL_SETTING_OPTIONS,

      toCropImage: false,
      visibleImageCropper: false,
      croppedImage: false,

      causeTag: '',
      causeDisplayTags: [],

      orgTag: '',
      orgDisplayTags: [],
    }
  },
  validations: {
    detailForm: {
      groupName: {
        required,
      },
    },
  },
  computed: {
    goalsLabel() {
      return GOALS_LABEL
    },
  },
  watch: {
    causeTag: 'getCauses',
    orgTag: 'searchOrganization',
  },
  mounted() {
    this.fetchGroupsHierarchy()
    this.setEditValues()
  },
  methods: {
    fetchGroupsHierarchy() {
      store
        .dispatch('adminGroups/fetchGroupsHierarchy', {
          companyId: this.companyId,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            this.groups = data
          }
        })
    },
    setEditValues() {
      if (this.groupItem.id) {
        const groupItem = this.groupItem
        const { name, start, end, causes, goals } = groupItem

        this.detailForm.groupName = name
        this.detailForm.start =
          start && start !== EMPTY_TIME ? parseISO(start) : start
        this.detailForm.end = end && end !== EMPTY_TIME ? parseISO(end) : end
        this.detailForm.parentId = groupItem.parent_id
        this.detailForm.imageUrl = groupItem.image_url
        this.detailForm.postTypes = groupItem.post_types

        this.detailForm.causeTags = this.changeDataToTags(causes)
        if (groupItem.charity_organization) {
          const selectedOrg = []
          selectedOrg.push(groupItem.charity_organization)
          this.detailForm.orgTags = this.changeDataToTags(selectedOrg)
        }

        if (goals.length) {
          this.detailForm.goals = goals
          // TODO: Is this correct?
          if (goals[0].end === EMPTY_TIME) {
            this.detailForm.goalSetting = 'number'
          }
        }
        if (groupItem.goalsEnd && groupItem.goalsEnd !== EMPTY_TIME) {
          this.detailForm.goalsEnd = parseISO(groupItem.goalsEnd)
        }
      } else {
        this.detailForm.goals = GOALS_DATA
      }
    },
    clickOnFileUpload() {
      this.$refs.file.click()
    },
    uploadFiles(event) {
      var input = event.target
      if (input.files && input.files.length > 0) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.toCropImage = {
            original: e.target.result,
            cropped: null,
          }
        }
        reader.readAsDataURL(input.files[0])
        this.visibleImageCropper = true
      }
    },
    onClose() {
      this.visibleImageCropper = false
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      this.toCropImage.cropped = canvas.toDataURL()
    },
    finishCropping() {
      this.crop()
      this.croppedImage = this.toCropImage.cropped
      this.detailForm.imageUrl = this.croppedImage
      this.visibleImageCropper = false
    },
    changeDataToTags(data) {
      if (!data || !data.length) return data
      const newData = data.map((item) => {
        const { id, name } = item
        return { id, text: name }
      })
      return newData
    },
    filterData(data) {
      if (!data.length) return data
      const newData = data.map((item) => {
        return { id: item.id, name: item.text }
      })
      return newData
    },
    updateCauseTags(newTags) {
      this.detailForm.causeTags = newTags
    },
    getCauses() {
      if (this.causeDisplayTags.length) {
        return
      }
      store.dispatch('adminGroups/getCauses').then((data) => {
        if (data instanceof Array && data.length) {
          this.causeDisplayTags = this.changeDataToTags(data)
        }
      })
    },
    updateOrgTags(newTags) {
      this.orgDisplayTags = []
      this.detailForm.orgTags = newTags
    },
    searchOrganization: debounce(async function searchUsers() {
      if (!this.orgTag || this.detailForm.orgTags.length) {
        return
      }
      store
        .dispatch('adminGroups/searchOrganization', {
          orgTag: this.orgTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            this.orgDisplayTags = this.changeDataToTags(data)
          }
        })
    }, 500),
    getFormData() {
      const vuelidate = this.$v.detailForm
      vuelidate.$touch()
      // if its still pending or an error is returned do not submit
      if (vuelidate.$pending || vuelidate.$error) {
        this.$emit('trigger-detail-tab')
        return {}
      }
      // to form submit after this
      const {
        groupName,
        parentId,
        start,
        end,
        imageUrl,
        postTypes,
        goals,
        goalSetting,
        goalsEnd,
        causeTags,
        orgTags,
      } = this.detailForm

      const org = orgTags.length
        ? JSON.stringify(this.filterData(orgTags))
        : null
      const causesData =
        causeTags && causeTags.length
          ? JSON.stringify(this.filterData(causeTags))
          : null

      return {
        name: groupName,
        parent_id: parentId || 0,
        start: isDate(start) ? start.toISOString() : parseISO(start),
        end: isDate(end) ? end.toISOString() : parseISO(end),
        image_url: imageUrl,
        post_types: postTypes,
        goals: JSON.stringify(goals),
        goal_setting: goalSetting,
        goals_end: isDate(goalsEnd)
          ? goalsEnd.toISOString()
          : parseISO(goalsEnd),
        causes: causesData,
        charity_organization: org,
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="w-3/5 mx-auto">
      <div class="flex justify-between">
        <div class="mb-10 w-1/2 pr-6">
          <BaseInputText
            id="name"
            v-model="detailForm.groupName"
            :vuelidate="$v.detailForm.groupName"
            label="Group Name: *"
            required
          />
        </div>
        <div class="mb-10 w-1/2 pr-6">
          <BaseTreeSelect
            v-model="detailForm.parentId"
            label="Parent Group:"
            :options="groups"
          />
        </div>
      </div>

      <div class="flex justify-between">
        <div class="mb-10 w-1/2 pr-6">
          <BaseFormGroup id="startDate" label="Start Date:">
            <div class="relative">
              <Datepicker
                v-model="detailForm.start"
                :disabled-dates="{ to: new Date() }"
                input-class="border cursor-pointer input border-gray-light focus:border-gray"
              />
              <span
                class="absolute inset-y-0 right-0 flex items-center mr-4 pointer-events-none"
              >
                <BaseIcon name="calendar" class="text-blue" :size="22" />
              </span>
            </div>
          </BaseFormGroup>
        </div>
        <div class="mb-10 w-1/2 pr-6">
          <BaseFormGroup id="endDate" label="End Date:">
            <div class="relative">
              <Datepicker
                v-model="detailForm.end"
                :disabled-dates="{ to: new Date() }"
                input-class="border cursor-pointer input border-gray-light focus:border-gray"
              />
              <span
                class="absolute inset-y-0 right-0 flex items-center mr-4 pointer-events-none"
              >
                <BaseIcon name="calendar" class="text-blue" :size="22" />
              </span>
            </div>
          </BaseFormGroup>
        </div>
      </div>

      <div>
        <label class="block mb-3">Group Image:</label>
        <div class="flex">
          <div class="relative">
            <div
              class="w-28 h-28 rounded-full border border-gray-dark overflow-hidden align-middle"
            >
              <img :src="detailForm.imageUrl" class="w-full rounded-full" />
            </div>

            <div
              class="border border-blue-default rounded-full absolute bottom-0 right-0 p-2.5 bg-white w-10 h-10 cursor-pointer"
              @click="clickOnFileUpload"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.494"
                height="16.611"
                viewBox="0 0 19.494 16.611"
              >
                <g
                  id="Group_336"
                  data-name="Group 336"
                  transform="translate(-3 -2)"
                >
                  <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M19.774,18.611H5.72A2.72,2.72,0,0,1,3,15.891V8.347a2.72,2.72,0,0,1,2.72-2.72H7.08l.453-1.655A3.239,3.239,0,0,1,10.707,2h4.08a3.239,3.239,0,0,1,3.173,1.972l.453,1.655h1.36a2.72,2.72,0,0,1,2.72,2.72v7.544A2.72,2.72,0,0,1,19.774,18.611ZM5.72,6.534A1.813,1.813,0,0,0,3.907,8.347v7.544A1.813,1.813,0,0,0,5.72,17.7H19.774a1.813,1.813,0,0,0,1.813-1.813V8.347a1.813,1.813,0,0,0-1.813-1.813H18.06a.454.454,0,0,1-.453-.331l-.553-1.986a2.323,2.323,0,0,0-2.267-1.31h-4.08A2.323,2.323,0,0,0,8.44,4.217L7.892,6.2a.454.454,0,0,1-.453.331Z"
                  />
                  <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M19.08,23.16a4.08,4.08,0,1,1,4.08-4.08,4.08,4.08,0,0,1-4.08,4.08Zm0-7.254a3.173,3.173,0,1,0,3.173,3.173A3.173,3.173,0,0,0,19.08,15.907Z"
                    transform="translate(-6.56 -7.106)"
                  />
                  <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M35.36,16.72a1.36,1.36,0,1,1,1.36-1.36A1.36,1.36,0,0,1,35.36,16.72Zm0-1.813a.453.453,0,1,0,.453.453A.454.454,0,0,0,35.36,14.907Z"
                    transform="translate(-16.946 -6.56)"
                  />
                </g>
              </svg>
            </div>
          </div>

          <div class="relative">
            <input
              ref="file"
              type="file"
              class="absolute bottom-0 w-20 opacity-0"
              multiple
              accept="image/*,video/*"
              @change="uploadFiles($event)"
            />
            <button
              class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mb-1 absolute bottom-0"
              @click="clickOnFileUpload"
            >
              Upload
            </button>
            <BaseModalWindow
              modalcls="w-user-edit bg-white rounded-xl mx-10 px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
              :visible="visibleImageCropper"
              @close="onClose"
            >
              <template v-slot:body>
                <div class="w-full mx-auto mt-12 mb-5">
                  <div class="">
                    <Cropper
                      v-if="toCropImage"
                      ref="cropper"
                      :stencil-props="{
                        aspectRatio: 1 / 1,
                      }"
                      classname="w-full"
                      :src="toCropImage.original"
                    />
                  </div>

                  <div class="mt-3">
                    <button
                      class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
                      @click="finishCropping"
                    >
                      Done
                    </button>
                  </div>
                </div>
              </template>
            </BaseModalWindow>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-20 px-8">
      <div class="mb-10 w-1/2 pr-6">
        <BaseSelectBox
          id="postTypes"
          v-model="detailForm.postTypes"
          :options="postTypesOptions"
          label="Post types:"
        />
      </div>

      <h3 class="text-2xl text-blue-darker mb-5">Goals</h3>
      <div class="flex flex-wrap justify-between mb-10">
        <div
          v-for="(goalItem, index) in detailForm.goals"
          :key="goalItem.id"
          class="w-1/4 pr-6 pt-3"
        >
          <BaseInputText
            :id="`${goalItem.type + index}`"
            v-model="detailForm.goals[index].goal"
            :label="`${goalsLabel[goalItem.type]}:`"
            placeholder="0"
          />
        </div>
      </div>
      <div class="flex mb-10">
        <div class="w-1/2 pr-6">
          <BaseSelectBox
            id="goalSetting"
            v-model="detailForm.goalSetting"
            :options="goalSettingOptions"
            label="Goal Settings:"
          />
        </div>
        <div v-if="detailForm.goalSetting === 'time'" class="w-1/2 pr-6">
          <BaseFormGroup id="goalsEndDate" label="End Date:">
            <div class="relative">
              <Datepicker
                v-model="detailForm.goalsEnd"
                :disabled-dates="{ to: new Date() }"
                input-class="border cursor-pointer input border-gray-light focus:border-gray"
              />
              <span
                class="absolute inset-y-0 right-0 flex items-center mr-4 pointer-events-none"
              >
                <BaseIcon name="calendar" class="text-blue" :size="22" />
              </span>
            </div>
          </BaseFormGroup>
        </div>
      </div>

      <div class="flex">
        <div class="w-1/2 pr-6">
          <label for="causes" class="block mb-3">
            Target a causes (optional):
          </label>
          <div class="relative" @click="getCauses">
            <VueTagsInput
              v-model="causeTag"
              :tags="detailForm.causeTags"
              :autocomplete-items="causeDisplayTags"
              :add-only-from-autocomplete="true"
              :add-on-blur="false"
              :autocomplete-min-length="0"
              placeholder="What Cause?"
              @tags-changed="updateCauseTags"
            />
          </div>
        </div>
        <div class="w-1/2 pr-6">
          <label for="organization" class="block mb-3"
            >Target an organization (optional):</label
          >
          <VueTagsInput
            v-model="orgTag"
            :tags="detailForm.orgTags"
            :max-tags="1"
            :maxlength="detailForm.orgTags.length ? 0 : 10"
            :autocomplete-items="orgDisplayTags"
            :add-only-from-autocomplete="true"
            :add-on-blur="false"
            placeholder="What Organization?"
            @tags-changed="updateOrgTags"
          />
        </div>
      </div>
    </div>
  </div>
</template>
